import styled from 'styled-components';
import { media } from '@minecraft.themes';

type CropperProps = {
  sideViewTools?: boolean | string;
  lessSm?: boolean;
  isThumbnail?: boolean;
};

type IconProps = {
  'data-qa-id': string;
  sideViewTools: boolean | string;
  isActive?: boolean;
};


export const CropperBlockWrapper = styled.div`
  display: inline-block;
`;

export const CropperWrapper = styled.div<CropperProps>`
  display: flex;
  flex-flow: column-reverse wrap;
  align-items: center;
  width: auto;
  height: auto;
  margin: 0 auto;

  ${media.sm`
    flex-flow: row wrap;
    justify-content: center;
    align-items: initial;
  `}

  .image-cropper {
    width: ${(props): string => props.lessSm ? '16.63rem' : '28.13rem'};
    height: ${(props): string => props.lessSm ? '16.63rem' : '28.13rem'};
    img {
      width: 100%;
    }
  }

  .cropper-point {
    border-radius: 50%;

    &.point-se {
      height: 0.3125rem;
      width: 0.3125rem;
    }
  }

  & > div > img:not(.cropper-hidden) {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const CroppingToolsContainer = styled.div<CropperProps>`
  display: flex;
  flex-flow: row wrap;
  margin-top: 1rem;
  ${media.sm`
    margin-top: 0;
    flex-flow: column wrap;
    align-items: flex-end;
  `}
  ${media.md`
    flex-direction: ${(props):string => (props.sideViewTools ? 'column' : 'initial')};
  `}
`;

export const CroppingToolsWrap = styled.div<CropperProps>`
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: ${(props):string => (props.sideViewTools ? '0' : '0.8125rem')};
  height: ${(props):string => (props.sideViewTools ? 'max-content' : 'auto')};
  ${media.md`
    height: ${(props):string => (props.sideViewTools ? 'auto' : 'max-content')};
    flex-direction: ${(props):string => (props.sideViewTools ? 'row' : 'initial')};
    flex-wrap: ${(props):string => (props.sideViewTools ? 'wrap' : 'initial')};
  `}
  button {
    padding: 0.375rem 0.75rem;
    margin-bottom: 0.5rem;
    margin-right: 1.5rem;
    font-size: 0.875rem;
    min-width: 0;
  }
`;

export const StyledIconsWrap = styled.div<CropperProps>`
  border-radius: ${(props):string => props.theme.button.borderRadius};
  border: 0.0625rem solid ${(props):string => props.theme.colors.primary.primary};
  overflow: hidden;
  display: flex;
  margin-bottom: ${(props):string => (props.sideViewTools ? '0.5rem' : '0')};
  margin-right: ${(props):string => (props.sideViewTools ? '1.5rem' : '0')};
  &:first-child {
    margin-right: 1.5rem;
  }

  ${media.md`
    flex-direction: ${(props):string => (props.sideViewTools ? 'column' : 'initial')};
  `};
`;

export const StyledIconsWrapButton = styled.div`
  flex: auto;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  width: 100%;
  ${media.sm` width: auto; `}
`;

export const StyledResetButton = styled(StyledIconsWrapButton)`
  align-items: flex-start;
  margin-left: 1rem;
  flex: initial;

  button {
    padding: 0;
    min-width: 4rem;
  }
`;

const getBackgroundStyle = (props): string => props.isActive
  ? props.theme.colors.accent.blueActive
  : 'none';

export const StyledIcon = styled.div<IconProps>`
  background: ${getBackgroundStyle};
  cursor: pointer;
  padding: 0 0.5625rem;
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;
  border-right: 0.0625rem solid ${(props):string => props.theme.colors.primary.primary};
  &:last-child {
    border-bottom: none;
    border-right: none;
  }

  ${media.md`
    border-right: ${(props):string => props.sideViewTools
      ? 'none'
      : `0.0625rem solid ${props.theme.colors.primary.primary}`};
    border-bottom: ${(props):string => props.sideViewTools
      ? `0.0625rem solid ${props.theme.colors.primary.primary}`
      : 'none'};
  `};
`;

export const StyledIconRotated = styled(StyledIcon)<IconProps>`
  background: ${getBackgroundStyle};
  svg {
    transform: scaleX(-1);
  }
`;

export const StyledMobileIconsWrapper = styled.div`
  border: 1px solid ${(props): string => props.theme.colors.primary.primary};
  border-radius: 4px;
  display: flex;
  margin: 1rem 1rem 1rem 0;
  ${media.sm`
    margin: 1rem 1rem 1rem;
    display: block;
  `}
`;

export const StyledThumbIconsBlock = styled.div`
    flex: auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    ${media.sm`
        flex-flow: column wrap;
        justify-content: center;
    `}
`;

export const StyledThumbResetBtnWrap = styled(StyledIconsWrapButton)`
  flex: initial;
`;

export const ThumbnailNote = styled.div`
  text-align: center;
`;
